import React from 'react'
import Modal from 'core/elements/modal'
import Button from 'core/elements/button'
import Text from 'core/elements/Text'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import { formatDate } from 'utils/misc'

const getColorBasedOnSeverity = (theme: Theme, severity: string) => {
  switch (severity) {
    case 'Critical':
      return theme.components.badge.error.color
    case 'Warning':
      return theme.components.badge.warning.color
    case 'Info':
      return theme.components.badge.secondary.color
    default:
      return theme.components.badge.unknown.color
  }
}

interface StyleProps {
  severity: string
}

const AlertTitle = ({ alert }) => {
  const classes = useStyles({ severity: alert.severity })
  return (
    <div className={classes.titleContainer}>
      <FontAwesomeIcon className={classes.icon}>exclamation-circle</FontAwesomeIcon>
      <Text variant="subtitle1">Alert Title</Text>
    </div>
  )
}

export default function AlertDetailsDialog({ alert, onClose }) {
  const classes = useStyles({ severity: alert.severity })
  return (
    <Modal
      panel="dialog"
      title={<AlertTitle alert={alert} />}
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} icon="trash-alt">
            Delete Alert
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      <div className={classes.detailsContainer}>
        <div className={classes.infoContainer}>
          <Text variant="caption1">Severity:</Text>
          <Text variant="caption1" className={classes.infoLabel}>
            {alert.severity}
          </Text>
        </div>
        <div className={classes.infoContainer}>
          <Text variant="caption1">Timestamp:</Text>
          <Text variant="body2">{formatDate(alert.timestamp)}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Text variant="caption1">Description:</Text>
          <Text variant="body2">
            Some detailed description about the alert that could be long or short
          </Text>
        </div>
      </div>
      <div className={classes.infoContainer}>
        <Text variant="caption1">How To Resolve:</Text>
        <Text variant="body2">
          Tell the user how this issue can be resolved by clicking on the button below. The button
          below should perform some action or redirect the user to a page where they can resolve the
          issue.
        </Text>
      </div>
      <div className={classes.actionsContainer}>
        <Button variant="primary" onClick={onClose} icon="wrench">
          Some Action To Resolve Issue
        </Button>
      </div>
      <div className={classes.actionsContainer}></div>
    </Modal>
  )
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  titleContainer: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  icon: {
    color: ({ severity }) => getColorBasedOnSeverity(theme, severity),
  },
  infoContainer: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    gap: theme.spacing(1),
  },
  infoLabel: {
    color: ({ severity }) => getColorBasedOnSeverity(theme, severity),
  },
  detailsContainer: {
    display: 'grid',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  actionsContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
}))
